import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    d="M20 12C20 16.4183 16.4183 20 12 20M4 12C4 7.58172 7.58172 4 12 4"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
  />,
  'Spinner',
)
